import { Host, hosts } from './Hosts';
import EventEmitter from 'events';

declare global {
    interface Window {
        hostClient: any;
    }
}

/**Host client determines the app host */
class HostClient extends EventEmitter {
    public host: Host;
    constructor() {
        super();
        this.host = this.getHost();
    }
    /**Can override host */
    public setHost(hostName: Host) {
        this.host = hostName;
        this.emit('host-changed');
    }
    /**Loops through the host object to check if the host equals any of them else it defaults to partners */
    private getHost(): Host {
        const hostLookup: Record<string, string> = hosts;
        const host = window.origin.toLowerCase();
        for (const keys in hosts) {
            const hostValue = hostLookup[keys];
            if (host.includes(hostValue)) {
                return hostValue as Host;
            }
        }
        return hosts.partners;
    }
}

const hostClient = new HostClient();

console.log('The host is', hostClient.host);

if (process.env.REACT_APP_ENVIRONMENT !== 'prod') {
    /**Allow us to edit the host client via the window */
    window.hostClient = hostClient;
}

export default hostClient;
